export default __webpack_public_path__ + "static/media/trophies.90a435a8.svg";